function loadImage(source) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => resolve(image);
        image.onerror = () => reject(new Error("Image decode failed"));
        image.src = source;
    });
}

function encodeCanvas(canvas, maxLength, initialQuality = 0.82, minQuality = 0.55, qualityStep = 0.07) {
    let quality = initialQuality;
    let optimized = canvas.toDataURL("image/jpeg", quality);

    while (optimized.length > maxLength && quality > minQuality) {
        quality -= qualityStep;
        optimized = canvas.toDataURL("image/jpeg", quality);
    }

    return optimized;
}

export function fileToDataUrl(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(new Error("File read failed"));
        reader.readAsDataURL(file);
    });
}

export async function getImageAspectRatio(source) {
    const image = await loadImage(source);
    return image.width / image.height;
}

export async function optimizeImageForFlipbook(source, options = {}) {
    const {
        maxWidth = 1200,
        maxHeight = 1700,
        targetAspectRatio = null,
        maxLength = 900000,
        backgroundColor = "#000000"
    } = options;

    const image = await loadImage(source);
    const scale = Math.min(1, maxWidth / image.width, maxHeight / image.height);
    const drawWidth = Math.max(1, Math.round(image.width * scale));
    const drawHeight = Math.max(1, Math.round(image.height * scale));

    let canvasWidth = drawWidth;
    let canvasHeight = drawHeight;

    if (targetAspectRatio && Number.isFinite(targetAspectRatio) && targetAspectRatio > 0) {
        const currentRatio = drawWidth / drawHeight;
        if (currentRatio > targetAspectRatio) {
            canvasHeight = Math.max(1, Math.round(drawWidth / targetAspectRatio));
        } else if (currentRatio < targetAspectRatio) {
            canvasWidth = Math.max(1, Math.round(drawHeight * targetAspectRatio));
        }
    }

    const canvas = document.createElement("canvas");
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;

    const ctx = canvas.getContext("2d");
    if (!ctx) {
        throw new Error("Canvas context unavailable");
    }

    ctx.fillStyle = backgroundColor;
    ctx.fillRect(0, 0, canvasWidth, canvasHeight);

    const x = Math.round((canvasWidth - drawWidth) / 2);
    const y = Math.round((canvasHeight - drawHeight) / 2);
    ctx.drawImage(image, x, y, drawWidth, drawHeight);

    return encodeCanvas(canvas, maxLength);
}
